import React,{useEffect,useState} from 'react';
import styled from 'styled-components';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import { AppState } from '../../store';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { setCurrentCategory, setSubCategoriesStatus,getCategory } from '../../store/categories/functions';
import {Form} from '../../store/forms/types';

import Link from '../elements/link';
import { fetchFormInstances,finder } from '../../store/forms/functions';
import { Card, CardActionButton, TableNew, DescriptionBox } from '../elements';
import { CONSTS } from '../elements/_constants';
import moment from 'jalali-moment'
import persify from 'persify'
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';
type FormsListComponentProps = {
    className?: string,
    match: any,
    onSetCurrentCategoryId: Function,
    onToggleSubCategories: Function,
    onFetchFormInstances: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    currentForm: Form,
}
const FormsListComponent = (props: FormsListComponentProps) => {
    useEffect(() => {
        props.onToggleSubCategories(true);
        return () => {};
    }, [])

    useEffect(() => {
        props.onSetCurrentCategoryId(parseInt(""+props.match.params.id));
        props.onFetchFormInstances(parseInt(""+props.match.params.formId));
        return () => {};
    }, [props.match.params.id])

    let columns: any[] = props.currentForm && [...props.currentForm.columns, {
      title: "",
      style: {width: 50},
      dataIndex: "_more",
      render: (id :number) => <Link style={{color:CONSTS.colors.greyDarker}} to={`${props.match.url}/items/${id}`}>مشاهده</Link>
    }];

    props.currentForm && props.currentForm.columns.map((col:any, i) => {
      if(i===0) col.style = {width: 40};
      if(col.dataIndex==="_timestamp"){
        col['render'] = (t:string) => {
          // 2019-11-05T15:39:08
          // t = "2019-11-05T16:40:00";
          return persify(""+moment(t, 'YYYY-MM-DDTHH:mm:ss').locale('fa').format('YYYY/MM/DD - HH:mm'));
        }
      }
    })
    let dataSource: any[] = [];
    props.currentForm && props.currentForm.dataSource.map((item, i) => {
      item['_more'] = item._id;
      dataSource.push(item)
    })

    return (
        <div className={props.className}>
          <Card
              title={props.currentForm && props.currentForm.title}
              headerMeta={<>
                <CardActionButton title="ایجاد مورد جدید" to={`${props.match.url}/new`} iconClassName="icon-icons8-plus_math" hasBorderRight={true}/>
              </>}
            >
              <div style={{padding: 20}}>
              {props.currentForm && props.currentForm.description.length > 229 && <DescriptionBox content={<FroalaEditorView model={props.currentForm.description} />} style={{marginBottom:10}}/>}
              {props.currentForm && <TableNew dataSource={dataSource} columns={columns} />}
              </div>
            </Card>
        </div>
    )
}
const FormsList = styled(FormsListComponent)`
`
const mapStateToProps = (state: AppState,ownProps: any) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,
  currentForm: state.forms.forms[finder(parseInt(`${ownProps.match.params.formId}`),state.forms.forms)]
});

const mapDispatchToProps = (dispatch:any) => ({
      onSetCurrentCategoryId  : (id: number)      =>{
        dispatch(setCurrentCategory(id));
      },
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      },
      onFetchFormInstances    : (formId: number)  =>{
        dispatch(fetchFormInstances(formId));
      }
});
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FormsList));
